import isEmpty from "is-empty";

const CheckBoxText = (props) => {
    const {el = {}, insertColors = {}} = props;
    const {key, doc_count} = el;

    if (isEmpty(el)) return null;

    let text = el.value;
    if (doc_count) {
        text += ' (' + doc_count + ')';
    }
    let icon = null;

    if (el.key === 'insertsColor') {
        if (el.value === 'Бесцветный') {
            icon = <span className={`iconNotColor`}></span>;
        } else if (insertColors[el.value]) {
            const style = {
                backgroundColor: insertColors[el.value],
                ...(el.value === 'Белый' ? {borderColor: '#e8e8f0'} : {}),
            };
            icon = <span className={`iconWithColor`} style={style}></span>;
        }
    }

    // if (el.key !== 'insertsColor') {
    //     return el.value;
    // } else {
    //     if (el.valueAlias === 'bescvetnyj') {
    //         return <>
    //             <span className={`iconNotColor`}></span>
    //             {el.value}
    //         </>
    //     } else {
    //         let style = {};
    //         if (el.valueAlias === 'zelenyj') style = {backgroundColor: '#008000'};
    //         if (el.valueAlias === 'krasnyj') style = {backgroundColor: '#ff0000'};
    //         if (el.valueAlias === 'sinij') style = {backgroundColor: '#0000ff'};
    //         if (el.valueAlias === 'chernyj') style = {backgroundColor: '#000000'};
    //         if (el.valueAlias === 'goluboj') style = {backgroundColor: '#42aaff'};
    //         if (el.valueAlias === 'korichnevyj') style = {backgroundColor: '#964b00'};
    //         if (el.valueAlias === 'sirenevyj') style = {backgroundColor: '#c8a2c8'};
    //         if (el.valueAlias === 'rozovyj') style = {backgroundColor: '#ffc0cb'};
    //         if (el.valueAlias === 'zheltyj') style = {backgroundColor: '#ffff00'};
    //         if (el.valueAlias === 'limonnyj') style = {backgroundColor: '#fde910'};
    //         if (el.valueAlias === 'oranzhevyj') style = {backgroundColor: '#ffa500'};
    //         if (el.valueAlias === 'fioletovyj') style = {backgroundColor: '#8b00ff'};
    //         if (el.valueAlias === 'belyj') style = {backgroundColor: '#ffffff', borderColor: '#e8e8f0'};
    //         if (el.valueAlias === 'seryj') style = {backgroundColor: '#808080'};
    //         if (el.valueAlias === 'bezhevyj') style = {backgroundColor: '#eee5cf'};
    //         if (el.valueAlias === 'biryuzovyj') style = {backgroundColor: '#01cec2'};
    //         if (el.valueAlias === 'lavandovyj') style = {backgroundColor: '#e6e6fa'};
    //
    //         return <>
    //             <span className={`iconWithColor`} style={style}></span>
    //             {el.value}
    //         </>
    //     }
    // }

    return (
        <>
            {icon}
            {text}
        </>
    );
}

export default CheckBoxText;
